import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import { saveAs } from 'file-saver';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { ESC_KEY_CODE } from '@components/Modal/Login/LoginModal';
import { ModalTypes } from '@components/Modal/Modal';
import TrainingMaterialTemplate from '@components/TrainingMaterial/TrainingMaterial';
import TrainingRecordTemplate from '@components/TrainingRecord/TrainingRecord';
import TrainingCertificateClerkData from './TrainingCertificateClerkData';
import { useGTM } from '@hooks/useGTM';
import CheckboxTemplate from '@ui/Checkbox/Checkbox';
import useTranslations from '@hooks/useTranslation';
import ButtonTemplate from '@ui/Button/Button';
import { parseModulesFromAccessToken } from '@utils/auth.utils';
import Cookies from 'js-cookie';
import moment from 'moment/moment';
import { ACCESS_TOKEN_KEY, ACCESS_TOKEN_KEY_GUEST, REFRESH_TOKEN_KEY, ROUTES } from '../../constants';
import { ITrainingItemDate, ITrainingItemCourse } from '../../interfaces/Calendar';
import { authApi } from '../../services/auth.service';
import { calendarApi } from '../../services/calendar.service';
import { RootState } from '../../store';
import { openModalType, setIsLoggedIn as setIsLoggedInState } from '../../store/ui';
import {
    Wrapper,
    Preview,
    CheckboxLabel,
    LabelBox,
    ButtonBox,

} from './TrainingCertificate.elements';

export interface TrainingCertificateProps {
    dates: ITrainingItemDate[];
    course: ITrainingItemCourse;
    trainingModules: string[];
}

const TrainingCertificateTemplate: FC<TrainingCertificateProps> = ({ dates: trainingDates, course, trainingModules }) => {
    const { t } = useTranslations();

    const router = useRouter();

    const isLoggedInState = useSelector((state: RootState) => state.ui.isLoggedIn);

    const [isLoading, setIsLoading] = useState(false);

    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [activeDate, setActiveDate] = useState(null);
    const [user, setUser] = useState(null);
    const [courseEnded, setCourseEnded] = useState(false);
    const [hasSubscription, setHasSubscription] = useState(false); //rocny balik
    const [generateClerkCert, setGenerateClerkCert] = useState(false);

    useEffect(() => {
        if (isLoggedIn && user) {
            const userModules = parseModulesFromAccessToken(Cookies.get(ACCESS_TOKEN_KEY));
            const subscription = !!trainingModules?.find((trainingModule) => userModules?.includes(trainingModule));
            setHasSubscription(subscription)
        }
    }, [isLoggedIn, user]);

    useEffect(() => {
        if (trainingDates?.length > 0) {
            setActiveDate(trainingDates?.find((date) => date.date._key === router.query.termin) || trainingDates?.[0]);
        }
    }, [trainingDates]);

    useEffect(() => {
        if (isLoggedIn) {
            authApi
                .getUser()
                .then(({ data }) => {
                    setUser(data);
                })
                .catch();
        } else {
            setUser(null);
        }
    }, [isLoggedIn]);

    useEffect(() => {
        setIsLoggedIn(isLoggedInState);
    }, [isLoggedInState]);

    useEffect(() => {
        if (
            moment().local().diff(activeDate?.date?.to, 'minutes') > 0 &&
            activeDate?.streams?.length === 0
        ) {
            return setCourseEnded(true);
        }

    }, [activeDate]);

    const handlePDF = (key: string) => {
        setIsLoading(true);
        calendarApi
            .getTrainingCertificate(key, Cookies.get(ACCESS_TOKEN_KEY), true)
            .then(({ data }) => {
                saveAs(data, `certifikat.pdf`);
                setIsLoading(false);
            })
            .catch();
    };



    return (
        trainingDates?.length > 0 && (activeDate?.accessible || hasSubscription) && (
            <Wrapper>

                {courseEnded && (
                    <Preview>

                        {course?.clerk && (
                            <LabelBox>
                                <CheckboxTemplate
                                    name="billing"
                                    checked={generateClerkCert}
                                    onChange={() => setGenerateClerkCert(!generateClerkCert)}
                                >
                                    <CheckboxLabel>
                                        Chci vygenerovat úřednický certifikát
                                    </CheckboxLabel>
                                </CheckboxTemplate>
                            </LabelBox>
                        )}

                        <ButtonBox>
                            <ButtonTemplate
                                isLoading={isLoading}
                                onClick={() => handlePDF(course._key)}
                                disabled={isLoading}
                                marginTop={25}
                                text={t('material.download.certificate')}
                            />
                        </ButtonBox>

                    </Preview>

                )}

                {!courseEnded && (
                    <Preview>

                        <CheckboxLabel>
                            {t('material.download.info')}
                        </CheckboxLabel>

                    </Preview>


                )}

                {generateClerkCert && course?.clerk && (
                    <TrainingCertificateClerkData
                        onClose={() => setGenerateClerkCert(false)}
                        course={course}
                        userKey={user._key}
                    />
                )}

            </Wrapper>
        )
    );
};

export default TrainingCertificateTemplate;
